export default {
	namespaced: true,
	state: {
		asyncDone: true,
		asyncText: ""
	},
	getters: {
		state(state) {
			return state.asyncDone
		},
		text(state) {
			return state.asyncText
		}
	},
	mutations: {
		stateMutate(state, payload) {
			state.asyncDone = payload.state;
			if(payload.text !== undefined){
				state.asyncText = payload.text;
			}
		}
	},
	actions: {
		stateUpdate(context, payload) {
			context.commit('stateMutate', payload)
		}
	}
}
